var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('CourseHeader',{attrs:{"imgSrc":require(`@/assets/outils.png`),"title":"Page en cours de construction...","subtitle":""}}),_c('DocumentDisplayer'),_c('ForumPanel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }